import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#0052B4" d="M0 20c0 11.046 8.954 20 20 20V20H0Z"></path><path fill="#D80027" d="M20 0c11.046 0 20 8.954 20 20H20V0Z"></path><path fill="#0052B4" d="m11.905 6.956 1.295 3.986h4.191l-3.39 2.464 1.295 3.985-3.39-2.463-3.391 2.463 1.295-3.985-3.39-2.464h4.19l1.295-3.986Z"></path><path fill="#D80027" d="m28.094 22.609 1.296 3.985h4.19l-3.39 2.464 1.295 3.986-3.39-2.464-3.391 2.464 1.295-3.986-3.39-2.463h4.19l1.295-3.986Z"></path>', 5), o = [
  h
];
function c(n, p) {
  return t(), e("svg", a, [...o]);
}
const d = { render: c };
export {
  d as default,
  c as render
};
